/* Parser and compiler:

Extremely basic string-slicing based parser/interpreter for Turing
machines.

Source code must be formatted as follows:
    `$startState;
    $startTapeContents;
    in state1 char1 out state2 char2 move1;
    in state3 char3 out state4 char4 move2;
    in state5 char5 out state6 char6 move3;
    ...`
newlines are not necessary, but each line ends 
with a semicolon.

line syntax is as follows:
    in [inputState] [inputCharacter] out [outputState] [outputCharacter] [outputMoveCommand];
[inputState] [inputCharacter] [outputState] [outputCharacter] 
    can be any strings except reserved keywords. 
[outputMoveCommand] must be either 'left' or 'right'
*/

/* TODO: almost certainly there are some built-in methods for 
pattern grabbing in javascript that could be used here */
function parserDiagram(source, state, character) {
  /** Reads source code, state and character
   * and returns the next instruction */
  var char = character;
  if (char === "") {
    char = "_";
  }
  const lengthOfInString = ("in " + state + " " + char + " out ").length;
  const startOfInStringPos = source.indexOf("in " + state + " " + char);
  if (startOfInStringPos === -1) {
    return null;
  }
  const endOfInStringPos = startOfInStringPos + lengthOfInString;
  const endLinePos = source.indexOf(";", startOfInStringPos);
  const nextInstructionString = source.slice(endOfInStringPos, endLinePos);
  const nextInstructionArray = nextInstructionString.split(" ");
  return {
    nextState: nextInstructionArray[0],
    printChar: nextInstructionArray[1],
    nextMove: nextInstructionArray[2],
  };
}

function compiler(sourceCode) {
  /* Compiles source code into a function that can be
   * passed to the TuringMachine constructor as a diagram */
  return function compiledDiagram(state, character) {
    return parserDiagram(sourceCode, state, character);
  };
}

/* TODO: almost certainly there are some built-in methods for 
pattern grabbing in javascript that could be used here */
function getInitialConfig(sourceCode) {
  /* Determines the initial state and tape contents specified
   * in a source code string */
  const startOfStateString = sourceCode.indexOf("$");
  const endOfStateString = sourceCode.indexOf(";", startOfStateString);
  const startOfInputString = sourceCode.lastIndexOf("$");
  const endOfInputString = sourceCode.indexOf(";", startOfInputString);
  const stateString = sourceCode.slice(
    startOfStateString + 1,
    endOfStateString
  );
  const inputString = sourceCode.slice(
    startOfInputString + 1,
    endOfInputString
  );
  return {
    startState: stateString,
    startInput: inputString,
  };
}

exports.compiler = compiler;
exports.getInitialConfig = getInitialConfig;
